import { Badge, ListRow } from "../../design-v2";
import OptionGlyph from "../../components/product/optionGlyphs";
import { ChevronRightGlyph } from "./settingsGlyphs";

export default function SettingsMenuRow({
  label,
  description,
  icon,
  showIcon = true,
  badge,
  meta,
  showSeparator = false,
  onClick,
}) {
  const showBadgeAsDot = !showIcon && Boolean(badge);

  return (
    <ListRow
      className={[
        "lz-settings-row",
        showSeparator ? "lz-settings-row--separated" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
      leading={
        showIcon && icon ? (
          <span className="lz-settings-row__icon" aria-hidden="true">
            <OptionGlyph name={icon} />
          </span>
        ) : null
      }
      title={label}
      description={description || undefined}
      meta={meta || undefined}
      trailing={
        <span className="lz-settings-row__trailing">
          {showBadgeAsDot ? (
            <span className="lz-settings-row__dot" role="img" aria-label={badge} />
          ) : badge ? (
            <Badge tone="danger">{badge}</Badge>
          ) : null}
          <ChevronRightGlyph className="lz-settings-row__chevron" />
        </span>
      }
    />
  );
}
